import React from 'react'
import PropTypes from 'prop-types'

import RadioGroup from '_components/radio-input-group'

const PREDICTOR_SCORES = {
  HIGH: 'High affinity',
  MEDIUM: 'Balanced',
  LOW: 'High reach',
}

const PredictorsScore = ({ topic, predictorScoreHeader, handleChange }) => {
  return (
    <div className="modal-offline-attribute__pred-score">
      <RadioGroup
        options={[
          {
            label: PREDICTOR_SCORES.HIGH,
            checked: PREDICTOR_SCORES.HIGH === (topic?.predictorScore ?? predictorScoreHeader),
            title: predictorScoreHeader ? 'Apply to all selected attributes' : '',
          },
          {
            label: PREDICTOR_SCORES.MEDIUM,
            checked: PREDICTOR_SCORES.MEDIUM === (topic?.predictorScore ?? predictorScoreHeader),
            title: predictorScoreHeader ? 'Apply to all selected attributes' : '',
          },
          {
            label: PREDICTOR_SCORES.LOW,
            checked: PREDICTOR_SCORES.LOW === (topic?.predictorScore ?? predictorScoreHeader),
            title: predictorScoreHeader ? 'Apply to all selected attributes' : '',
          },
        ]}
        groupName={topic?.attrName ?? 'header'}
        onChange={handleChange}
      />
    </div>
  )
}

PredictorsScore.defaultProps = {
  topic: null,
  predictorScoreHeader: null,
}

PredictorsScore.propTypes = {
  topic: PropTypes.object,
  predictorScoreHeader: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
}

export default PredictorsScore
